const trimTrailingSlash = (value = '') => value.replace(/\/+$/, '');
const toForwardSlashes = (value = '') => String(value || '').replace(/\\/g, '/');
const stripQueryAndHash = (value = '') => String(value || '')
    .split('#')[0]
    .split('?')[0]
    .trim();

export const getApiBaseUrl = () => trimTrailingSlash(process.env.REACT_APP_API_URL || '');

const extractCanonicalMediaPath = (assetPath = '') => {
    const rawValue = String(assetPath || '').trim();
    if (!rawValue || /^data:/i.test(rawValue)) {
        return '';
    }

    let candidate = rawValue;

    if (/^https?:\/\//i.test(rawValue)) {
        try {
            const parsedUrl = new URL(rawValue);
            candidate = decodeURIComponent(parsedUrl.pathname || '');
        } catch (_) {
            candidate = rawValue;
        }
    }

    const normalizedCandidate = toForwardSlashes(stripQueryAndHash(candidate));
    const mediaMatch = normalizedCandidate.match(/(?:^|\/)(uploads|files)\/(.+)$/i);

    if (!mediaMatch) {
        return '';
    }

    const normalizedPath = `${mediaMatch[1].toLowerCase()}/${mediaMatch[2]}`
        .replace(/^\/+/, '')
        .replace(/\\/g, '/');

    if (normalizedPath.includes('\0')) {
        return '';
    }

    const pathSegments = normalizedPath.split('/').filter(Boolean);
    if (pathSegments.length === 0 || pathSegments.some((segment) => segment === '.' || segment === '..')) {
        return '';
    }

    return pathSegments.join('/');
};

export const resolveAssetUrl = (assetPath) => {
    if (!assetPath) {
        return '';
    }

    if (/^data:/i.test(assetPath) || /^https?:\/\//i.test(assetPath)) {
        return assetPath;
    }

    const canonicalMediaPath = extractCanonicalMediaPath(assetPath);
    const normalizedPath = assetPath.startsWith('/') ? assetPath : `/${assetPath}`;
    const apiBaseUrl = getApiBaseUrl();

    if (canonicalMediaPath) {
        const mediaRoutePath = `/media/${canonicalMediaPath}`;
        return apiBaseUrl ? `${apiBaseUrl}${mediaRoutePath}` : mediaRoutePath;
    }

    if (apiBaseUrl) {
        return `${apiBaseUrl}${normalizedPath}`;
    }

    return normalizedPath;
};
